export const normalizeInviteEmail = (email: string) => email.trim().toLowerCase()
